require('./gallery');
require('./missions');

(() => {
    const slider = document.querySelector('[data-public-slider]');
    if (!slider || !window.Swiper) return;
    new window.Swiper(slider, {
        loop: slider.querySelectorAll('.swiper-slide').length > 1,
        speed: 800,
        autoplay: { delay: 6000, disableOnInteraction: false },
        keyboard: { enabled: true, onlyInViewport: true },
        effect: 'fade',
        fadeEffect: { crossFade: true }
    });
})();
